import DeleteConfirm from '../components/DeleteConfirm'
import EditDeleteActions from '../components/EditDeleteActions'

export default {
    components: {
        EditDeleteActions,
        DeleteConfirm,
    },

    data () {
        return {
            selected: [],
            search: '',
            deleteConfirm: false,
            deleteConfirmId: 0
        }
    },

    computed: {
        items () {
            return this.$store.state[this.module].list
        }
    },

    mounted() {
        if (this.module !== 'ticket') {
            this.$store.dispatch(`${this.module}/list`)
        }
    },

    methods: {
        addItem () {
            this.$refs.dialog.type = 'add'
            this.$refs.dialog.show()
        },
        editItem (detail) {
            this.$refs.dialog.type = 'edit'
            this.$refs.dialog.detail = detail
            this.$refs.dialog.show()
        },
        deleteItem (id) {
            this.deleteConfirmId = id
            this.deleteConfirm = true
        },
        async doDeleteConfirm () {
            this.deleteConfirm = false
            const res = await this.$store.dispatch(`${this.module}/delete`, this.deleteConfirmId)
            if (res && res.ok) {
                await this.$store.dispatch(`${this.module}/list`)
                this.$refs.dialog.hide()
            }
        },

        async onComplete (form) {
            let res
            if (this.$refs.dialog.type === 'add') {
                res = await this.$store.dispatch(`${this.module}/create`, form)
            } else {
                res = await this.$store.dispatch(`${this.module}/update`, form)
            }
            if (res && res.ok) {
                await this.$store.dispatch(`${this.module}/list`)
                this.$refs.dialog.hide()
            }
        }
    }
}

